/**
 * Mutations for person
 */
export const mutations = {
  setValidated(state, value) {
    state.validated = value;
  },
  setEditPersonId(state, value) {
    state.editPersonId = value;
  },
  setAddOrEditPerson(state, value) {
    state.addOrEditPerson = value;
  }
};
